<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H3yh9E/tc-custom/9781398486737.jpg?1705540911302" alt="This image is the cover for the book Chapters in the Mind of a Schizophrenic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chapters in the Mind of a Schizophrenic
      </h1>
      <p class="bookDescription body article font2">
        <p>The essence of my book I lost my mind And got it back with time My mind is a complex thing Only I know what it is like within Concealed in my skull It’s anything but dull I tried to keep it sane But it has its own brain I lost control and got it back But it’s that trust I lack Not knowing what comes next I converted my thoughts to text To try and understand Before I’m buried in the sand I kind of know how you tick But to society I am sick Labelled as mentally ill But I have a strong will To conquer my brain And learn how to maintain A level of sanity Enough to have clarity And function within the norm Without causing a storm I lost you twice As I rolled the dice Gambling with my mind Because I didn’t know what kind Of illness I was dealing with Now I know schizophrenia it is I try to make my peace With a mind that is never at ease Now I wrote this book And that much suffering it took To describe my mind But I think now it is perfectly timed To share this book With all the pain and sweat it took I hope to spark a conversation That puts us on track to that far destination Where acceptance is key And we can all live free By YM Mehanni</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        YM Mehanni
      </h2>
      
      <p class="authorDescription body article">YM Mehanni is a young man who grew up in the heart of Sudan (Africa). He enjoyed an adventurous life until circumstances dictated that he leaves his home in search for answers. After years of struggling, he was diagnosed with schizophrenia but that was when the real struggle began. He started the treatment which was the beginning of a long and turbulent trip. It took him down unexpected roads and into unchartered territories. But he managed to tough it out and lives to tell the story.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25921d30